import { render } from "./RobotInfo.vue?vue&type=template&id=6d570347&scoped=true"
import script from "./RobotInfo.vue?vue&type=script&lang=js"
export * from "./RobotInfo.vue?vue&type=script&lang=js"

import "./RobotInfo.vue?vue&type=style&index=0&id=6d570347&lang=scss"
import "./RobotInfo.vue?vue&type=style&index=1&id=6d570347&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6d570347"

export default script